var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-presentation-mode-user-board-title"},[_c('h4',{staticClass:"title-color text-truncate",attrs:{"title":_vm.userTitle}},[_vm._v(_vm._s(_vm.userTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }